export default "__VITE_ASSET__BqSQKqE___"